import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { defaultStepperState } from './types';
export const StepperContext = React.createContext({
    state: defaultStepperState,
    setState: () => {
        null;
    },
});
export const Stepper = props => {
    const [stepperState, setStepperState] = useState(Object.assign(Object.assign({}, defaultStepperState), { steps: props.steps, activeStep: props.activeStep }));
    const setState = (property, value) => {
        setStepperState(Object.assign(Object.assign({}, stepperState), { [property]: value }));
    };
    useEffect(() => {
        const stepLinks = [];
        for (const step in stepperState.steps) {
            stepLinks.push(Object.assign(Object.assign({}, stepperState.steps[step]), { active: stepperState.steps[step] === stepperState.activeStep, key: step }));
        }
        const activeIndex = stepLinks.findIndex(stepLink => stepLink.active);
        const previousMethod = () => {
            const key = stepLinks[activeIndex - 1].key;
            if (key)
                setStepperState((state) => {
                    return Object.assign(Object.assign({}, state), { activeStep: stepperState.steps[key] });
                });
        };
        const nextMethod = () => {
            const key = stepLinks[activeIndex + 1].key;
            if (key)
                setStepperState((state) => {
                    return Object.assign(Object.assign({}, state), { activeStep: stepperState.steps[key] });
                });
        };
        const toStepMethod = (stepKey) => {
            if (stepperState.steps[stepKey])
                setStepperState((state) => {
                    return Object.assign(Object.assign({}, state), { activeStep: stepperState.steps[stepKey] });
                });
        };
        setStepperState((state) => {
            return Object.assign(Object.assign({}, state), { stepLinks: stepLinks, activeIndex: activeIndex, methods: {
                    next: nextMethod,
                    previous: previousMethod,
                    toStep: toStepMethod,
                } });
        });
    }, [stepperState.steps, stepperState.activeStep, setStepperState]);
    return (_jsx(StepperContext.Provider, Object.assign({ value: {
            state: stepperState,
            setState: setState,
        } }, { children: props.children })));
};
